module.exports = __webpack_public_path__ + "img/product-shot_02_loading.ed46c960.jpg";